<template>
    <b-container fluid>
      <PortalNavbar show="true"></PortalNavbar>

      <LoginNewHome></LoginNewHome>

    <div class="footer-main">
      
      <b-nav class="">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/terms">Terms &amp; Conditions</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-light small" href="/#/privacy">Privacy</a>
          </li>
        </ul>
      </b-nav>
    </div>
    </b-container>
</template>

<script>
import LoginNewHome from "@/components/LoginNewHome";
import PortalNavbar from "@/components/PortalNavbar";
import { VueFlux, FluxPagination, Transitions } from "vue-flux";
import Photos from "@/components/Portal/Photos";

import carousel from 'vue-owl-carousel'
export default {
  components: {LoginNewHome, PortalNavbar, VueFlux, FluxPagination,carousel,Photos },
  data() {
    return {
      fluxOptions: {
        autoplay: true,
        barWidth: 300
      },

      fluxImages: [
        require("@/assets/images/slider-1.jpg"),
        require("@/assets/images/slider-2.jpg"),
        require("@/assets/images/slider-3.jpg"),
      
      ],
      fluxTransitions: {
        transitionWaterfall: Transitions.transitionWaterfall,
        transitionZip: Transitions.transitionZip,
        transitionBlocks2: Transitions.transitionBlocks2
      }
    };
  },
  methods: {
      onSlideStart(slide) {
        this.imagepath="~/assets/images/slider/image1.jpg"
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    },
  mounted(){
    this.$ua.trackView('Home');
  }
};
</script>

<style scoped>
.container{
    width:100% !important;
    overflow:hidden; /* Fixing Horizontal scrollbar overflow break */
}

.container-fluid{
  overflow:hidden;
}
.panel-heading {
  padding: 18px 15px;
}
.media {
  border-bottom: none;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 1.42857143;
  color: #333;
  padding-bottom: 10px;
  padding-top: 15px;
}
.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}

.h4,
h4 {
  font-size: 18px;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}

.panel-info-crc {
  border-color: #c90c5c;
}

.panel-info-crc > .panel-heading {
  color: #fefefe;
  background-color: #c90c5c;
  border-color: #c90c5c;
}

.panel-info-crc2 {
  border-color: #dc6800;
}

.panel-info-crc2 .panel-heading {
  color: #fefefe;
  background-color: #dc6800;
  border-color: #c90c5c;
}

.panel-primary .panel-heading {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}

.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  font-family: "Open sans", sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}

.media-body,
.media-left,
.media-right {
  display: table-cell;
  vertical-align: top;
}

.media-body {
  width: 10000px;
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}


.slider{
  height: 300px;
}


.about_us_area{
  font-family: 'Laila', serif;
}

.about_us_area .about_row p{
  font-family:'Laila', serif;
  color:#333;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  padding-top:15px;
  padding-bottom:0;
}

.about_us_area .about_row h2{
  color:#333;
}

.about-us-inner-img{

  width:100%;
  border-radius: 7px;
  border:1px solid #d3d3d3;
  
}

.read-more-btn{
  font-family: 'Open Sans', sans-serif;
  color:#fff;
  background:#ab7806;
  font-size:13px;
  font-weight:bold;
  display: block;
  padding:7px 20px;
  width: fit-content;
  border-radius: 4px;
  margin-top:5px;
}

@media(max-width: 1199px){
  .slider{
  height: 250px;;
}
}

@media(max-width:991px){
  .slider{
    height: 200px;
  }
}

.our_feature_area{
  padding-top:30px;
  padding-bottom: 30px;
  background-color: #f1f1f1;
  
}

@media(max-width: 767px){
  .about-us-inner-img{
    margin-top:0;
  }

  .about_us_area .about_row p{
    padding-bottom: 0;
  }

  .our_feature_area{
  padding-top:25px;
  padding-bottom:25px;
}
  .our_feature_area .feature-wrap{
    padding:15px;
  }
}


/* Out feature changes */



.our_feature_area .feature-wrap{
  width:fit-content;
  margin:auto;
  display:flex;
  align-items: center;
}

.our_feature_area .feature-wrap i{
  padding:20px;
  background:#ab7806;
  color:#fff;
  border-radius: 50%;
  margin-right: 10px;

}

.our_feature_area .feature-wrap a{
  color:#000;
  font-weight: bold;
  font-size: 14px;
  
}



@media(max-width: 575px){
    .our_feature_area{
      padding-right: 10px;
      padding-left: 10px;
      padding-top:10px;
      padding-bottom:10px;
    }
  .our_feature_area .feature-wrap{
    margin-top:10px;
    margin-bottom:10px;
  }

   .our_feature_area .feature-wrap a{
    font-size:13px;
  }

  .our_feature_area .feature-wrap i{
    padding:15px;
  }
}

@media(max-width:419px){
  .our_feature_area .feature-wrap{
    padding-left:0;
    padding-right:0;
  }
}

.our_feature_area .feature-wrap a{
  font-size:12px;
}

.our_feature_area .feature-wrap i{
  padding:10px;
}



</style>



// WEBPACK FOOTER //
// src/components/Home.vue